import { render } from "./PurchasesView.vue?vue&type=template&id=43fb59fe&scoped=true&ts=true"
import script from "./PurchasesView.vue?vue&type=script&lang=ts"
export * from "./PurchasesView.vue?vue&type=script&lang=ts"

import "./PurchasesView.vue?vue&type=style&index=0&id=43fb59fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fb59fe"]])

export default __exports__